import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/_organization/members/")({
  component: () => <Navigate to="/members/directory" />,
})
